import { environment } from 'src/environments/environment';

// ENVIRONMENT META
export const IS_PRODUCTION = environment.PRODUCTION;
export const ACTUAL_ENV = environment.ACTUAL_ENV;

// API V3
export const API_V3_URL = environment.API_V3_URL;
export const API_V3_KEY = environment.API_V3_KEY;
export const PASSWORD_TOKEN_SHA1 = environment.PASSWORD_TOKEN_SHA1;

// MIXPANEL SERVER SIDE-TRACKING
export const RELAY_URL = environment.RELAY_URL;
export const RELAY_AES_KEY = environment.RELAY_AES_KEY;

// SSO LOGIN
export const GOOGLE_OAUTH_CLIENT_ID = environment.GOOGLE_OAUTH_CLIENT_ID;
export const MICROSOFT_OAUTH_CLIENT_ID = environment.MICROSOFT_OAUTH_CLIENT_ID;
